import BaseService from '@/scripts/services/base/base.service'

export default class GeneralService extends BaseService {
    constructor() {
        super('Receipt')
    }

    receiptList(councilId) {
        return this.getRequest('ReceiptList', { councilId: councilId })
    }

    cancelReceipt(receiptId) {
        return this.getRequest('CancelReceipt', { receiptId: receiptId })
    }
    batchCancelReceipt(receiptIds, callback) {
        return this.postRequest('BatchCancelReceipt', receiptIds).then(callback);
    }

    saveReceiptSigned(callback, docs) {
        return this.postRequest('SaveReceiptSigned', docs).then(callback);
    }

    councilEntityList() {
        return this.getRequest('CouncilEntityList')
    }
}
